<template>
      <v-container fluid>
        <v-layout row wrap>

          <v-flex>
            <isrs-parcel-number-select
              :parcelNumberContainerId="returnShopPortal.parcelNumberContainerId"
              :parcelnumbercontainers="parcelnumbercontainers"
              @change="id => saveParcelNumberContainer(id)"
            ></isrs-parcel-number-select>
          </v-flex>

        </v-layout>
      </v-container>

</template>


<script>
import DataService from '../../services/data'
import {mapState, mapGetters} from 'vuex'

import IsrsParcelNumberSelect from '../../components/IsrsParcelNumberSelect.vue'

export default {
  components: {
    IsrsParcelNumberSelect
  },

  data() {
    return {
      parcelnumbercontainer: null,
      parcelnumbercontainers: [],
      returnportalparcelnumbercontainer: {}
    }
  },

  computed: {
    ...mapGetters('returnShopPortal', ['config', 'customer']),
    ...mapState('returnShopPortal', ['returnShopPortal'])
  },

  mounted() {
    this.dataService = new DataService(this.profile, this.$store.state.tokens)
    this.dataService.getCustomerParcelNumberContainerByUuid(this.customer.customerId)
      .then( result => result.data)
      .then( data => this.parcelnumbercontainers = data)
  },

  methods: {
    saveParcelNumberContainer(parcelNumberContainerId) {
      this.dataService.setReturnShopParcelNumberContainer(this.$store.state.returnShopPortal.returnShopPortal.id, parcelNumberContainerId)
    }
  }
}
</script>



// WEBPACK FOOTER //
// ParcelNumberContainers.vue?21fabb2a